import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title:
    "How much would a cyberattack cost your business? Find out in 20 seconds.",
  header:
    "How much would a cyberattack cost your business? Find out in 20 seconds.",
  date: "2025-11-13",
  description:
    "Why cyber risk is a business problem, and how our free 20-second analysis turns vague risk into clear numbers and actions.",
  category: "security",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
